<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>基地管理</el-breadcrumb-item>
        <el-breadcrumb-item>基地数据统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px" inline>
        <el-form-item label="领货时间：" prop="timeInterval">
          <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
        </el-form-item>
        <el-form-item v-if="!baseId" label="选择基地：" prop="farmId">
          <el-select clearable size="small" v-model="listParams.farmId" placeholder="请选择基地">
            <el-option v-for="item in baseNameList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange" :showPagerOnOnePage="false">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <!--<el-button-->
          <!--class="align-left"-->
          <!--type="primary"-->
          <!--size="small"-->
          <!--@click="exportExcel">-->
          <!--导出-->
          <!--</el-button>-->

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column prop="farmTitle" align="center" label="基地名称"> </el-table-column>

        <el-table-column prop="" align="center" label="菜品名称">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.goodTitle }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" align="center" label="菜品单价(元)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.goodOnSelfPrice }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" align="center" label="保障单价(元)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.goodPrice }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="goodWeight" align="center" label="菜品重量(g)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.goodWeight }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="goodCount" align="center" label="菜品数量(份)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.goodCount }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="350px" prop="supplypTime" align="center" label="领货时间">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.supplypTime }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="total" align="center" label="合计(元)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.total }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        timeInterval: ["", ""],
      },
      baseId: "",
      baseNameList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  created() {
    if (this.$route.params.baseId) {
      this.baseId = this.$route.params.baseId;
      this.listParams.farmId = this.$route.params.baseId;
    }
  },
  mounted() {
    this.loadTableData();

    this.loadBaseNameList();
  },
  methods: {
    /**
     * 初始化基地名称列表
     */
    loadBaseNameList() {
      this.$http({
        url: global.apiUrl + "/farm/title",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.baseNameList = res.body.data.dataList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          dateStart: this.listParams.timeInterval[0],
          dateEnd: this.listParams.timeInterval[1],
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        }
      );
      console.log(this.listParams.timeInterval);
      this.$http({
        url: global.apiUrl + "/farm/farm-production-data",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 导出excel
     */
    exportExcel() {},
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
